/** Whether the page is being looked at, and a way to hear when that may have changed. */
export interface PageVisibility {
  isVisible: () => boolean;
  /** Calls `listener` when the tab is shown or hidden, or the window gains focus. Returns the unsubscribe. */
  subscribe: (listener: () => void) => () => void;
}

/** The browser's: `document.visibilityState`, `visibilitychange` and the window's `focus`. */
export const documentVisibility: PageVisibility = {
  isVisible: () => document.visibilityState === 'visible',
  subscribe: (listener) => {
    document.addEventListener('visibilitychange', listener);
    window.addEventListener('focus', listener);
    return () => {
      document.removeEventListener('visibilitychange', listener);
      window.removeEventListener('focus', listener);
    };
  },
};
